import { supabase } from '../lib/supabase';
import { BrandSection } from '../types';

export const brandSectionService = {
    async getAll(): Promise<BrandSection[]> {
        const { data, error } = await supabase
            .from('brand_sections')
            .select('*')
            .order('display_order', { ascending: true });

        if (error) throw error;
        return data || [];
    },

    async update(id: string, updates: Partial<BrandSection>): Promise<BrandSection> {
        const { data, error } = await supabase
            .from('brand_sections')
            .update(updates)
            .eq('id', id)
            .select()
            .single();

        if (error) throw error;
        return data;
    },

    async create(section: Partial<BrandSection>): Promise<BrandSection> {
        const { data, error } = await supabase
            .from('brand_sections')
            .insert(section)
            .select()
            .single();

        if (error) throw error;
        return data;
    },

    async delete(id: string): Promise<void> {
        const { error } = await supabase
            .from('brand_sections')
            .delete()
            .eq('id', id);

        if (error) throw error;
    }
};
